/* LT-21b — Job Template helpers shared by Templates, TemplateEdit,
 * TenderCreate and TenderEstimate. */

/** `detail` may be a string or `{message, conflict}` (409 one-live-template rule). */
export function templateErrorMessage(err, fallback = "Request failed") {
  const d = err?.response?.data?.detail;
  if (!d) return fallback;
  return typeof d === "string" ? d : (d.message || fallback);
}

export function templateConflict(err) {
  const d = err?.response?.data?.detail;
  return err?.response?.status === 409 && d && typeof d === "object" ? d.conflict : null;
}

const plural = (n, one, many) => `${n} ${n === 1 ? one : many}`;

/** Human summary of an apply report: `{phases_added?, lines_inserted,
 *  flagged_archived[], skipped_draft[], skipped_missing[]}`. */
export function templateReportSummary(report, phaseCount) {
  if (!report) return { text: "", warnings: [] };
  const phases = phaseCount ?? report.phases_added;
  const parts = [];
  if (phases != null) parts.push(plural(phases, "phase", "phases"));
  parts.push(plural(report.lines_inserted || 0, "library line", "library lines"));
  const warnings = [];
  const arch = (report.flagged_archived || []).length;
  const draft = (report.skipped_draft || []).length;
  const missing = (report.skipped_missing || []).length;
  if (arch) warnings.push(`${plural(arch, "archived item", "archived items")} inserted and flagged for review`);
  if (draft) warnings.push(`${plural(draft, "draft item", "draft items")} skipped`);
  if (missing) warnings.push(`${plural(missing, "missing item", "missing items")} skipped`);
  return { text: parts.join(" · "), warnings };
}
